module.exports = __webpack_public_path__ + "static/media/right-angle-white.6a021a84.svg";